/** Created by azhou on 2019/3/29.*/
<template>
  <div class="border rounded p-3 pb-0 d-center-between flex-wrap bjys">
    <left-text-autocomplete  class="w-45 mb-3" leftText="门店名称" v-model="storeName" v-show="storeType != 4" @enter="searchSubmit" :storeType="storeType"/>
    <!-- <left-text-border class="w-45 mb-3" leftText="用户名称" v-model="userName"/> -->
    <!-- <left-text-border class="w-45 mb-3" type="number" leftText="手机号" v-model="storePhone" v-show="!$GFUN.isInArray([2],storeType)"/> -->
     
    <!-- <left-text-select class="w-45 mb-3" leftText="微信绑定" :options="$GVAR.bindWechatType" v-model="storeWechat"/> -->
    <left-text-select class="w-45 mb-3" leftText="按星级" :options="searchType.starArr"
                      v-model="storeStar" v-show="$GFUN.isInArray([3,6],storeType)"/>
    <left-text-select class="w-45 mb-3" leftText="认证状态" :options="$GVAR.verifyType" v-model="storeVerify"/>                  
    <!-- <left-text-select class="w-45 mb-3" leftText="签约类型" v-show="$GFUN.isInArray([3,5],storeType)"
                      :options="$GVAR.contractType" v-model="storeContract"/> -->
    <select-city class="mb-3 w-45"
                 leftText="省市区"
                 mutiBlocks
                 @getCityInfo="info => this.cityInfo = info"
                 :provinceId="cityInfo.province"
                 :cityId="cityInfo.city"
                 :districtIds="cityInfo.district.map(v => v.id)"
                 v-if="storeType==2||storeType==3"
                 />
    <div class="w-45 mb-3 ml-auto text-right">
      <el-button type="primary" size="small" icon="el-icon-search" @click="$GFUN.pageChange(1);searchSubmit()">搜索</el-button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'SearchCon',
    computed: {
      ...mapGetters(['storeInfo']),
      storeType() { return Number(this.$route.query.storeType) },
      searchType() {
        switch (this.storeType) {
          case 3:return {cn:'酒店',starArr:this.$GVAR.HotelStar.slice(1,10),start:'入住日期',end:'离店日期'}
          case 5:return {cn:'民宿',left:'入住日期',start:'入住日期',end:'离店日期'}
          case 6:return {cn:'景区',starArr:this.$GVAR.scenicStarArr,start:'开始日期',end:'结束日期'}
          case 1:return {cn:'门店',left:'购买时间',start:'开始日期',end:'结束日期'}
          default:return {cn:'门店'}
        }
      }
    },
    data() {
      return {
        storeName: '',
        userName: '',
        storePhone:'',
        storeStar:'',
        storeVerify:'',
        storeContract:'',
        storeWechat:'',
        cityInfo:{
          province:'',
          city:'',
          district:[]
        }
      }
    },
    watch: {
      'storeType':'initSearchCon'
    },
    methods:{
      //清空搜索条件
      initSearchCon() {
        this.storeName = '';
        this.userName = '';
        this.storePhone = '';
        this.storeStar = '';
        this.storeVerify = '';
        this.storeContract = '';
        this.storeWechat = '';
        this.storeWechat = '';
        this.cityInfo = {
          province:'',
          city:'',
          district:[]
        };

      },
      //提交搜索条件
      searchSubmit() {
        let data = {
          title:this.storeName,
          userName: this.userName,
          phone:this.storePhone,
          star:this.storeStar,
          verify:this.storeVerify,
          sign:this.storeContract,
          wechat:this.storeWechat,
          pro:this.cityInfo.province,
          city:this.cityInfo.city,
          dis:this.cityInfo.district.map(v => v.id),
        }
        this.$emit('getSearchCon',data);
      },
    }
  }
</script>
<style lang="scss" scoped>
  .bjys{
    box-shadow: 0px 0px 7px #eee;
  }
</style>

